/*
 * @Author: changdou.fe@bytedance.com
 * @Date: 2025-10-25 15:20:48
 * @LastEditors: changdou.fe@bytedance.com
 * @LastEditTime: 2025-12-08 12:02:56
 */
export const DEFAULT_LANG = 'en-US';
export const LOCAL_LANG_COOKIE = 'LOCAL_LANG_COOKIE';

export const DEFAULT_THEME = 'dark';
export const LOCAL_THEME_COOKIE = 'LOCAL_THEME_COOKIE';

export const DEFAULT_THEME_COLOR = 'dark-black';
export const LOCAL_THEME_COLOR_COOKIE = 'LOCAL_THEME_COLOR_COOKIE';

// 验证码邀请最多人数
export const INVITE_MODAL_CACHE_KEY = 'BILLION_INVITE_MODAL_CACHE_KEY_';
export const INVITE_MODAL_CACHE_DURATION = 24 * 60 * 60 * 1000; // 24小时，单位：毫秒

// 绑定邀请码弹窗缓存
export const BIND_INVITE_MODAL_CACHE_KEY = 'BILLION_BIND_INVITE_MODAL_CACHE_KEY_';
export const BIND_INVITE_MODAL_CACHE_DURATION = 24 * 60 * 60 * 1000; // 24小时，单位：毫秒
// 登录页面邀请码
export const LOGIN_INVITE_CODE_CACHE_KEY = 'BILLION_LOGIN_INVITE_CODE_CACHE_KEY_';
// 直播间
export const LIVE_ROOM_CACHE_KEY = 'BILLION_LIVE_ROOM_CACHE_KEY_';

// 礼物视频预加载缓存
export const GIFT_VIDEO_PRELOAD_CACHE_KEY = 'BILLION_GIFT_VIDEO_PRELOAD_CACHE';
export const GIFT_VIDEO_PRELOAD_CACHE_VERSION = '1.0'; // 缓存版本，用于未来升级时清理旧缓存

// 预览页跳转标识
export const FROM_PREVIEW_CACHE_KEY = 'BILLION_FROM_PREVIEW_CACHE_KEY';

// 帖子声音缓存
export const POST_SOUND_CACHE_KEY = 'BILLION_POST_SOUND_CACHE_KEY';

// 页面刷新标识
export const IS_RELOADING_CACHE_KEY = 'BILLION_IS_RELOADING_CACHE_KEY';

// 奖励计划弹窗
export const REWARD_MODAL_CACHE_KEY = 'BILLION_REWARD_MODAL_CACHE_KEY_';
export const REWARD_MODAL_CACHE_DURATION = 24 * 60 * 60 * 1000; // 24小时，单位：毫秒

// 弹幕设置（开关/字号/速度/不透明度/显示区域）
// V2: displayArea 从 number(0-1) 改成枚举（row1/row2/p25/p50/p75）
// V3: fontSize 从 small/medium/large 扩展成 xs/sm/md/lg/xl
export const DANMU_SETTINGS_CACHE_KEY = 'BILLION_DANMU_SETTINGS_CACHE_KEY_V3';
